import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type PlanbookEditor from "cc-frontend/services/planbook-editor"

@tagName("")
export default class DayMenuAddSpecialEvent extends Component {
  // args
  courses!: Array<Course>
  dateString!: string
  alreadyReceivedCourse = false
  goBack!: Function
  planbook!: Planbook
  closeMenu!: Function
  rotationCalendar!: RotationCalendar

  // services
  @service planbookEditor!: PlanbookEditor

  @action
  createAnnotation({ title, description, startDate, endDate }) {
    this.planbookEditor.addAnnotation({
      title: title,
      description: description,
      startDate: startDate,
      endDate: endDate,
      isOff: false,
      models: {
        planbook: this.planbook,
        rotationCalendar: this.rotationCalendar,
        courses: this.courses,
      },
      bumpDeleteOrNothing: "NOTHING",
    })
    this.closeMenu()
  }
}
